export class FunctionModel {
  public id = 0;
  public label = '';
  public order = 0;

  constructor() {}

  fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }

  public fromJSONs(jsons) {
    const refs: FunctionModel[] = [];
    jsons.forEach(json => {
      refs.push(new FunctionModel().fromJSON(json));
    });
    return refs;
  }
}
